module.exports = __webpack_public_path__ + "static/study-uk-education-advisors_certificate_of_achievement-b54fbf395a48b5cb2617fb68ae4a178d.png";